import isEmpty from 'lodash/isEmpty';
import { useFieldConfigsByEntity } from './fields';
import usePermissionCheck from './usePermissionCheck';
import { EntityType } from 'shared/constants/entityTypes';
import { ENABLED_MODULES } from 'shared/constants/fields';
import policies from 'shared/configs/rbac/accessPolicies';
import useAccessControl from './useAccessControl';

export default function useSourceParameters() {
  const moduleEnabled = usePermissionCheck(ENABLED_MODULES.SOURCES);
  const [sampleFieldConfigs] = useFieldConfigsByEntity(EntityType.SAMPLE);
  const hasReadPermission = useAccessControl(policies.route.sources);
  const hasCreatePermission = useAccessControl(policies.ui.sourceDropdownCreateBtn);

  const sourceFieldConfig = (sampleFieldConfigs || []).find(
    (f) => f.name.toUpperCase() === EntityType.SOURCE
  );
  const fieldShown = {
    globally: !isEmpty(sourceFieldConfig),
    onOrderRequest:
      !isEmpty(sourceFieldConfig) &&
      sourceFieldConfig.order_request_field,
  };
  const isEnabled = moduleEnabled && fieldShown.globally && hasReadPermission;
  const canCreate = moduleEnabled && hasCreatePermission && fieldShown.onOrderRequest;

  return { canCreate, isEnabled };
}
